import React from "react";
import "./NotFound.scss";

const PageNotFound = () => {

    return (
        <div className="not-found-container">
            <div className="error-code">404</div>
            <div className="error-message">Oops, Page Not Found</div>
            <div className="error-description">Sorry, but the requested page was not found.</div>
        </div>
    )
}

export default PageNotFound;